import aiIconBlue from "../../../assets/images/ai2.png";

const modalOverlayStyle = {
  zIndex: 1000000,
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  background: "rgba(0, 0, 0, 0.5)",
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "flex-start",
  paddingTop: "25px",
  paddingRight: "32px",
};

const messageStyle = (role) => ({
  alignSelf: role === "user" ? "flex-end" : "flex-start",
  background: role === "user" ? "#3b82f6" : "#ffffff",
  color: role === "user" ? "#ffffff" : "#0369a1",
  padding: "10px 14px",
  borderRadius: "12px",
  fontSize: "13px",
  maxWidth: "85%",
  boxShadow: "0 1px 2px rgba(0,0,0,0.05)",
  lineHeight: 1.5,
  border: role === "assistant" ? "1px solid #bfdbfe" : "none",
});

/** COBOT conversation modal. Chat persistence and network calls stay page-owned. */
export function CobotModal({
  isOpen,
  text,
  messages = [],
  isLoading,
  conversationRef,
  onClose,
  onResetAndClose,
  onTextChange,
  onSend,
}) {
  if (!isOpen) return null;

  const isSendDisabled = isLoading || !text.trim();

  return (
    <div className="modal CobotModal" style={modalOverlayStyle} onClick={onClose}>
      <div
        className="modal-content CobotModalContent"
        style={{
          maxWidth: "70.5%",
          width: "70.5%",
          background: "#fff",
          borderRadius: "20px",
          padding: 0,
        }}
        onClick={(event) => event.stopPropagation()}
      >
        <div className="modal-header">
          <button
            aria-label="Close COBOT"
            className="CloseButton"
            onClick={onResetAndClose}
            type="button"
          />
          <h3>Ask COBOT about patient</h3>
          <p>Get AI-powered insights about the patient</p>
        </div>
        <div className="modal-body CobotModalBody">
          <div style={{display: "flex", flexDirection: "column", gap: 12, marginBottom: 16}}>
            <textarea
              className="CobotInput"
              placeholder="Ask COBOT about patient:"
              aria-label="Ask COBOT about patient"
              value={text}
              onChange={(event) => onTextChange(event.target.value)}
              style={{
                resize: "vertical",
                height: "6em",
                lineHeight: "1.2em",
                padding: "12px",
                borderRadius: 8,
                border: "1px solid #cbd5e1",
                outline: "none",
                fontSize: 14,
                fontFamily: "inherit",
                width: "100%",
                boxSizing: "border-box",
                fontWeight: 500,
              }}
            />
            <button
              onClick={onSend}
              disabled={isSendDisabled}
              style={{
                padding: "10px 20px",
                borderRadius: 8,
                border: "none",
                background: isSendDisabled ? "#cbd5e1" : "#3b82f6",
                color: "#fff",
                cursor: isSendDisabled ? "not-allowed" : "pointer",
                fontWeight: 600,
                fontSize: 14,
                transition: "background 0.3s ease",
              }}
              type="button"
            >
              {isLoading ? "Sending..." : "Send"}
            </button>
          </div>

          <div
            ref={conversationRef}
            style={{
              marginTop: 16,
              padding: 12,
              borderRadius: 8,
              minHeight: "150px",
              maxHeight: "300px",
              overflowY: "auto",
              background: "#f0f9ff",
              border: "1px solid #bfdbfe",
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            {messages.length > 0 ? (
              messages.map((message, index) => (
                <div key={message?.id ?? index} style={messageStyle(message.role)}>
                  {message.role === "assistant" && (
                    <div
                      style={{
                        fontWeight: "bold",
                        marginBottom: "4px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      <img src={aiIconBlue} alt="AI" style={{width: "14px", height: "14px"}} />{" "}
                      COBOT:
                    </div>
                  )}
                  {message.text}
                </div>
              ))
            ) : (
              <p style={{color: "#94a3b8", textAlign: "center", margin: "auto", fontSize: 13}}>
                Ask a question and COBOT will respond here...
              </p>
            )}
            {isLoading && (
              <div
                style={{
                  alignSelf: "flex-start",
                  background: "#ffffff",
                  padding: "10px 14px",
                  borderRadius: "12px",
                  fontSize: "13px",
                  color: "#94a3b8",
                  fontStyle: "italic",
                  border: "1px solid #bfdbfe",
                }}
              >
                Cobot is thinking...
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
